import React, { createContext, useContext, useState, useEffect } from 'react';
import settingsAPI from '../api/settings';
import { setActiveCurrency } from '../utils/helpers';

const CURRENCY_SYMBOLS = {
  USD: '$', EUR: '€', GBP: '£', INR: '₹',
  AED: 'AED ', SAR: 'SAR ', SGD: 'S$', AUD: 'A$',
  CAD: 'C$', JPY: '¥', CNY: '¥',
};

const CurrencyContext = createContext({ currency: 'USD', symbol: '$', formatCurrency: (v) => v });

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState('USD');

  const setCurrency = (c) => {
    setCurrencyState(c);
    setActiveCurrency(c);
  };

  useEffect(() => {
    if (!localStorage.getItem('token')) return;
    settingsAPI.getCompanySettings()
      .then(res => { if (res?.settings?.currency) setCurrency(res.settings.currency); })
      .catch(() => {});
  }, []);

  const symbol = CURRENCY_SYMBOLS[currency] || currency + ' ';

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '-';
    const num = Number(amount);
    if (isNaN(num)) return '-';
    if (Math.abs(num) >= 10000000) return `${symbol}${(num / 10000000).toFixed(2)} Cr`;
    if (Math.abs(num) >= 100000) return `${symbol}${(num / 100000).toFixed(2)} L`;
    return `${symbol}${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, symbol, formatCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
export default CurrencyContext;
